export default {
  CloseWhite: require("./ic-close-white.svg").default,
  IcChecked: require("./ic-checked.svg").default,
  IcUnChecked: require("./ic-unchecked.svg").default,
};
